import { getElementDefinitionProps } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
import _ from 'lodash';
import { elementTypes } from 'crazyEditor/components/Elements/index';
import { addIsTextElementIndication } from '../shared/sharedDataFixer';
import { PADDING_PROP_NAMES } from 'crazyEditor/core/constants/panelConstants';

function updateElementType(element) {
  let newElementType = null;
  switch (element.type) {
    case 'title':
      newElementType = elementTypes.TitleElement;
      break;
    case 'richText':
      newElementType = elementTypes.RichTextElement;
      break;
    case 'image':
      newElementType = elementTypes.ImageElement;
      break;
    case 'shape':
      newElementType = elementTypes.ShapeElement;
      break;
    case 'icon':
      newElementType = elementTypes.IconElement;
      break;
    case 'html':
      newElementType = elementTypes.HtmlElement;
      break;
    case 'video':
      newElementType = elementTypes.MobileVideoElement;
      break;
    case 'gallery':
      newElementType = elementTypes.MobileGalleryElement;
      break;
    case 'tabs':
      newElementType = elementTypes.MobileTabsElement;
      break;
    case 'page':
      newElementType = elementTypes.PageElement;
      break;
    case 'crossSellGallery':
      newElementType = elementTypes.MobileCrossSellGalleryElement;
      break;
    default:
      newElementType = null;
  }

  if (newElementType) {
    element.type = newElementType;
  }
}
/*
 Full width components X axis cannot be changed, thus it must be equal to 0
 */
function fixFullWidthComponents(element, elementDefinitionProps) {
  if (elementDefinitionProps.fullWidth) {
    element.layout.x = 0;
  }
}

/*
 Remove old element props/data from element structure.
 */
function omitOldElementProps(element, elementDefinitionProps) {
  const keysToDelete = [].concat(_.keys(elementDefinitionProps));
  _.forEach(keysToDelete, (keyToDelete) => delete element[keyToDelete]);
  switch (element.type) {
    case elementTypes.MobileTabsElement:
      delete element.compProps.backgroundColor;
      break;
    default:
      break;
  }
  element.data = {fontSizeInPercentFromDesktop: _.get(element, 'data.fontSizeInPercentFromDesktop'), compProps: {fontSize: _.get(element, 'data.compProps.fontSize')}};
  element.compProps = {zIndex: parseInt(_.get(element, 'compProps.zIndex'), 10) || null};
}

/*
  Add gallery data
 */
function addGalleryData(element) {
  if (element.type === elementTypes.MobileGalleryElement) {
    if (_.isUndefined(element.data.showThumbnails)) {
      element.data.showThumbnails = false;
    }
    if (_.isUndefined(element.data.showDottedNav)) {
      element.data.showDottedNav = true;
    }
    if (_.isUndefined(element.data.alwaysShowNavArrow)) {
      element.data.alwaysShowNavArrow = true;
    }
    _.forEach(PADDING_PROP_NAMES, (propName) => {
      if (_.isUndefined(element.compProps[propName])) {
        element.compProps[propName] = 0;
      }
    });
  }
}

/*
  This function must be called before omitOldElementProps
 */
function addFontSizeInPercentFromDesktop(element, elementDefinitionProps, desktopElement) {
  if (element.type === elementTypes.RichTextElement && !_.get(element, 'data.fontSizeInPercentFromDesktop')) {
    const htmlElementDesktop = document.createElement('div');
    const htmlElementMobile = document.createElement('div');
    htmlElementDesktop.innerHTML = desktopElement.data.rawHTML;
    htmlElementMobile.innerHTML = element.data.rawHTML;
    const allInnerElementsDesktop = htmlElementDesktop.getElementsByTagName('*');
    const allInnerElementsMobile = htmlElementMobile.getElementsByTagName('*');
    let desktopFontSize;
    let mobileFontSize;
    for (let i = 0; i < allInnerElementsDesktop.length; ++i) {
      desktopFontSize = parseInt(_.get(allInnerElementsDesktop, `[${i}].style.fontSize`), 10);
      mobileFontSize = parseInt(_.get(allInnerElementsMobile, `[${i}].style.fontSize`), 10);
      if (desktopFontSize) {
        break;
      }
    }
    if (!mobileFontSize) {
      mobileFontSize = parseInt(_.get(element, 'data.compProps.fontSize'), 10);
    }
    if (mobileFontSize && desktopFontSize) {
      element.data.fontSizeInPercentFromDesktop = Math.round(100 * mobileFontSize / desktopFontSize);
    }
  }
}

function mobileDataFixer(element, desktopElement) {
  updateElementType(element);

  const elementDefinitionProps = getElementDefinitionProps(element.type);
  const fixerFn = [addFontSizeInPercentFromDesktop, fixFullWidthComponents, omitOldElementProps, addIsTextElementIndication, addGalleryData];
  _.forEach(fixerFn, (fn) => fn.call(this, element, elementDefinitionProps, desktopElement));

  return element;
}

function removeMissingDesktopElements(mobileElements, desktopElements) {
  _.forEach(mobileElements, mobileElement => {
    if (!desktopElements[mobileElement.desktopId]) {
      delete mobileElements[mobileElement.id];
    }
  });
}

export {
  mobileDataFixer,
  removeMissingDesktopElements,
};
